import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon, TrendingUpIcon, CrownIcon } from 'lucide-react';
export function PathsSection() {
  const paths = [{
    icon: SparklesIcon,
    title: 'ROOKIE',
    subtitle: 'For high-potential individuals with little or no experience',
    traits: ['You have hunger', 'You have drive', 'You want purpose'],
    income: '$40K–$80K',
    cta: 'See your path'
  }, {
    icon: TrendingUpIcon,
    title: 'OPERATOR',
    subtitle: 'For those with 1–4 years of experience',
    traits: ['You know the game', 'You want to level up', 'You want leadership'],
    income: '$80K–$150K',
    cta: 'See your path',
    featured: true
  }, {
    icon: CrownIcon,
    title: 'FORGE LEADER',
    subtitle: 'For those ready to build, manage and scale',
    traits: ['You want ownership', 'You want impact', 'You want legacy'],
    income: '$150K+',
    cta: 'See your path'
  }];
  return <section id="paths" className="py-32 px-6 bg-[var(--forge-black)] relative overflow-hidden" data-id="element-64">
      {/* Background accent */}
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[var(--forge-lava)] opacity-5 blur-[150px] rounded-full" data-id="element-65" />

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-66">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-20" data-id="element-67">
          <h2 className="text-5xl md:text-6xl font-black tracking-tighter mb-4" data-id="element-68">
            CHOOSE YOUR <span className="text-[var(--forge-lava)]" data-id="element-69">PATH</span>
          </h2>
          <p className="text-xl text-[var(--forge-gray)]" data-id="element-70">
            Where do you see yourself?
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-71">
          {paths.map((path, index) => <motion.div key={path.title} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.15
        }} whileHover={{
          y: -8,
          scale: 1.02
        }} className={`relative bg-[var(--forge-charcoal)] border-2 p-8 cursor-pointer group ${path.featured ? 'border-[var(--forge-lava)] shadow-2xl shadow-[var(--forge-lava)]/20' : 'border-[var(--forge-steel)] hover:border-[var(--forge-lava)]/50'}`} data-id="element-72">
              {path.featured && <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[var(--forge-lava)] px-4 py-1 text-xs font-black tracking-wider" data-id="element-73">
                  MOST POPULAR
                </div>}

              <path.icon className="w-16 h-16 text-[var(--forge-lava)] mb-6" data-id="element-74" />

              <h3 className="text-3xl font-black tracking-tight mb-2" data-id="element-75">
                {path.title}
              </h3>
              <p className="text-sm text-[var(--forge-gray)] mb-6 leading-relaxed" data-id="element-76">
                {path.subtitle}
              </p>

              <div className="space-y-3 mb-8" data-id="element-77">
                {path.traits.map(trait => <div key={trait} className="flex items-center gap-2" data-id="element-78">
                    <div className="w-1.5 h-1.5 bg-[var(--forge-lava)] rotate-45" data-id="element-79" />
                    <span className="text-sm text-[var(--forge-white)]" data-id="element-80">
                      {trait}
                    </span>
                  </div>)}
              </div>

              <div className="border-t border-[var(--forge-steel)] pt-6 mb-6" data-id="element-81">
                <div className="text-sm text-[var(--forge-gray)] mb-1" data-id="element-82">
                  Income Range
                </div>
                <div className="text-2xl font-black text-[var(--forge-lava)]" data-id="element-83">
                  {path.income}
                </div>
              </div>

              <button className="w-full py-3 bg-transparent border border-[var(--forge-lava)] text-[var(--forge-lava)] font-bold text-sm tracking-wide group-hover:bg-[var(--forge-lava)] group-hover:text-white transition-all duration-300" data-id="element-84">
                {path.cta.toUpperCase()}
              </button>
            </motion.div>)}
        </div>
      </div>
    </section>;
}